// src/pages/conocimiento/components/BusquedaConocimiento.tsx
import { useState, useEffect } from 'react';
import { Search, X, Loader2 } from 'lucide-react';
import { Input } from '@/components/ui';
import { useBuscarArticulos } from '@/hooks/queries/useConocimiento';
import { ArticulosList } from './ArticulosList';

export function BusquedaConocimiento() {
  const [query, setQuery] = useState('');
  const [debouncedQuery, setDebouncedQuery] = useState('');

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedQuery(query);
    }, 300);
    return () => clearTimeout(timer);
  }, [query]);

  const { data: resultados, isLoading } = useBuscarArticulos(debouncedQuery);

  return (
    <div className="space-y-4">
      <div className="relative">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-400" />
        <Input
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="Buscar artículos..."
          className="pl-10 pr-10"
          autoFocus
        />
        {query && (
          <button
            onClick={() => {
              setQuery('');
              setDebouncedQuery('');
            }}
            className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
          >
            <X className="h-5 w-5" />
          </button>
        )}
      </div>

      {debouncedQuery.length >= 2 && (
        <div>
          {isLoading ? (
            <div className="flex items-center justify-center py-8">
              <Loader2 className="h-6 w-6 animate-spin text-blue-600" />
              <span className="ml-2 text-gray-500">Buscando...</span>
            </div>
          ) : (
            <>
              <p className="text-sm text-gray-500 mb-4">
                {resultados?.length || 0} resultado(s) para "{debouncedQuery}"
              </p>
              <ArticulosList articulos={resultados || []} />
            </>
          )}
        </div>
      )}

      {debouncedQuery.length > 0 && debouncedQuery.length < 2 && (
        <p className="text-sm text-gray-500 text-center py-4">
          Escribe al menos 2 caracteres para buscar
        </p>
      )}
    </div>
  );
}
